/* Compute todays' date */

export default {
  computed: {
    todaysDate() {
      return new Date();
    },
  },
};
